import { httpDelete, httpDeleteWithPayload, httpGet, httpPost, httpPut } from '../../data'
import type { IGoal, IGoalFormData, IGoalList, IParticipant, IParticipantsList } from '../../../domain/interfaces/IGoal'

// Check this
const goalsUrl = '/goals'
const participantsUrl = '/participants'

export async function createGoal(goalData: IGoalFormData) {
  // no additional headers and direct data parsing is false
  return await httpPost<IGoal>(goalsUrl, goalData, undefined, false)
}

export async function updateGoal(goalData: IGoalFormData, id: string) {
  return await httpPut<IGoal>(`${goalsUrl}/${id}`, goalData, false)
}

export async function goalsGet(queryString: string) {
  return await httpGet<IGoalList>(`${goalsUrl}?${queryString}`, false)
}

export async function goalGetById(id: string) {
  return await httpGet<IGoal>(`${goalsUrl}/${id}`)
}

export async function deleteGoals(goalIds: string[]) {
  return await httpDeleteWithPayload<IGoalList>(`${goalsUrl}/bulk`, { goalIds })
}

export async function deleteGoalById(id: string) {
  return await httpDelete<IGoal>(`${goalsUrl}/${id}`)
}

export async function goalsSearch(searchTerm: string) {
  return await httpGet<IGoal[]>(`${goalsUrl}?searchKey=${searchTerm}`, false)
}

export async function participantsGet(queryString: string) {
  return await httpGet<IParticipantsList>(`/goals/participants?${queryString}`, false)
}

export async function participantGetById(id: string) {
  return await httpGet<IParticipant>(`${participantsUrl}/${id}`)
}

export async function participantsDelete(participantsIds: string[]) {
  return await httpDeleteWithPayload<IParticipantsList>(participantsUrl, { participantsIds })
}
